import * as app from "./scripts/app";
import "./styles/nota.scss";
import * as Banners from './scripts/common/banners';
import * as Share from "./scripts/common/compartir";
import * as Galeria from "./scripts/common/slide";
import * as Functions from "./scripts/common/functions";
import * as Utilities from "./scripts/common/utilities";
import "./scripts/common/livefyre/livefyre.js";
import * as LiveFyre from "./scripts/common/livefyre/framework";
import "./scripts/common/storytelling";
import * as Tercera from "./scripts/common/tercera";
import * as Login from "./scripts/common/login";
import * as Logout from './scripts/common/logout';
//import * as Movil from './scripts/common/menu-movil';
import { banners } from "../Settings/global.json";
import * as Cookie from './scripts/common/cookie';
import * as Tablero from './scripts/common/tableros';
import * as TableroTenis from './scripts/common/tableros/tableroTenis';
import * as TableroFutbol from './scripts/common/tableros/tableroFutbol';
import * as TableroRugby from './scripts/common/tableros/tableroRugby';
import * as TableroBasquet from './scripts/common/tableros/tableroBasket';
import * as Sugerencias from './scripts/nota/sugerencias';
import * as LiveBlog from './scripts/nota/liveBlog';
import * as NotasAdicionales from './scripts/nota/notasAdicionales';
import './scripts/common/jquery.mobile-1.4.5.js';
import * as bomba from './scripts/common/bombaIntrasitio';
import * as Personalizacion from './scripts/common/personalizacion';
import * as CustomDimension from './scripts/common/analytics/CustomDimension.js';
import * as NotaCustomDimension from './scripts/nota/NotaCustomDimension.js';
import * as Session from './scripts/common/session.js';
import * as Video from "./scripts/common/video";
import * as Footer from './scripts/common/footer';
import { termicas } from "../Settings/global.json";
import * as Pym from "./scripts/common/pymFunction.js";

window.LN = {};
window.LN.tipoPaginaBanner = "nota";
window.LN.configBanners = banners;
const dominio = window.config.Statics.DominioUrl;
const httpDominio = "http:" + dominio;

var FirstQuarter = false;
var SecondQuarter = false;
var ThirdQuarter = false;
var FourthQuarter = false;
var EventFinContenido = false;
var EventFinSugerencias = false;
var CommentsLoad = false;


//Set click event to Facebook and Twitter buttons.
const shareClickEvents = () => {
    if (document.querySelector("div[data-notaId]") !== null) {
        const notaId = document.querySelector("div[data-notaId]").getAttribute("data-notaId");
        const titulo = document.querySelector("div[data-titulo]").getAttribute("data-titulo");
        //facebooks
        Array.from(document.querySelectorAll('button[data-id="facebookShare"]')).map((o) => {
            o.addEventListener("click",
                () => {
                    Share.popUpCompartirNotaFB(notaId, httpDominio);
                    if (window.dataLayer != undefined) {
                        dataLayer.push({ 'event': 'shareItem', 'socialNetwork': 'facebook' });
                    }
                });
        });
        //twitter
        Array.from(document.querySelectorAll('button[data-id="twitterShare"]')).map((o) => {
            o.addEventListener("click",
                () => {
                    Share.popUpCompartirNotaTW(notaId, httpDominio, titulo);
                    if (window.dataLayer != undefined) {
                        dataLayer.push({ 'event': 'shareItem', 'socialNetwork': 'twitter' });
                    }
                });
        });

        Array.from(document.querySelectorAll('button[data-id="emailShare"]')).map((e) => {
            e.addEventListener("click",
                (e) => {
                    var notaUrl = e.target.getAttribute("data-url");
                    window.location.href =
                        `mailto:?subject=Te%20recomiendo%20esta%20nota%20de%20LA%20NACION&body=Lee%20esta%20nota%20de%20LA%20NACION%3A%20${
                        dominio}${notaUrl}`;
                    if (window.dataLayer != undefined) {
                        dataLayer.push({ 'event': 'shareItem', 'socialNetwork': 'mail' });
                    }
                });
        });

        //Array.from(document.querySelectorAll('button[data-id="whatsAppShare"]')).map((e) => {
        //    e.addEventListener("click",
        //        (e) => {
        //            var notaUrl = e.target.getAttribute("data-url");
        //            let textShare =  "https://api.whatsapp.com/send?text=" + notaUrl;
        //            window.open(textShare,'_blank');
        //            if (window.dataLayer != undefined) {
        //                dataLayer.push({ 'event': 'shareItem', 'socialNetwork': 'WhatsApp' });
        //            }
        //        });
        //});

        //google
        //document.querySelector('button[data-id="googleShare"').addEventListener("click", () => {
        //    Share.popUpCompartirNotaGoogle(notaId, httpDominio, titulo);
        //});
        //rss
        //document.querySelector('button[data-id="rssShare"').addEventListener("click", () => {
        //    Share.popUpCompartirNotaRss();
        //});

        //WhatsApp

        Share.shareWhatsAppDesktop();
        Share.shareWhatsAppMobile();

        ////Blockquotes
        //let nodeShareQuote = document.querySelectorAll("blockquote");
        //for (let element of Array.from(nodeShareQuote)) {
        //    const blockquote = element.querySelector("label");
        //    if (blockquote) {
        //        const blockquoteText = blockquote.innerHTML;
        //        const twBtn = element.querySelector("div > .icon-twitter");
        //        if (twBtn) {
        //            twBtn.addEventListener("click", () => {
        //                Share.popUpCompartirNotaTW(notaId, httpDominio, blockquoteText);
        //            });
        //        }
        //        const fbBtn = element.querySelector("div > .icon-facebook");
        //        if (fbBtn) {
        //            fbBtn.addEventListener("click", () => {
        //                Share.popUpCompartirNotaFB(notaId, httpDominio, blockquoteText);
        //            });    
        //        }
        //    }
        //}

        ////Images
        //assignEventsClicksShare(document.querySelectorAll("figure[data-is='imagen']"), "imagen");
        ////shareGalery
        //assignEventsClicksShare(document.querySelectorAll("#slider"), "galeria");
    }
};

const eventsMetrics = () => {
    Array.from(document.querySelectorAll('[data-DLdescripcion]'))
        .filter(k => k.getAttribute("data-DLdescripcion") != null &&
            k.getAttribute("data-DLdescripcion") !== "" &&
            k.getAttribute("data-DLdescripcion") !== undefined).map((d) => {
            d.addEventListener("click",
                () => {
                    if (window.dataLayer != undefined && d.getAttribute("class") !== "seguir activo") {
                        window.dataLayer.push({
                            'event': 'followAuth',
                            'followedAuth': d.getAttribute("data-DLdescripcion")
                        });
                    }
                });
        });

    Array.from(document.querySelectorAll('[data-event]'))
        .filter(t => t.getAttribute("data-event") != null && t.getAttribute !== "").map((tag) => {
            tag.addEventListener("click",
                () => {

                    if (window.dataLayer != undefined) {
                        window.dataLayer.push({ 'event': 'contentLinkClick' });
                    }
                });
        });
    //GS: YES por notaId
    const notaId = document.getElementById("hs-notaId") ?  document.getElementById("hs-notaId").value : "";
    Array.from(document.getElementsByClassName("icon-me-gusta")).map((like) => {
        like.addEventListener("click",
            () => {
                if (window.dataLayer != undefined) {
                    dataLayer.push({ 'event': 'trackEvent', 'eventCategory': 'engagement', 'eventAction': 'like', 'eventLabel': notaId, 'nonInteraction': false });
                }
                document.querySelectorAll(".icon-me-gusta").forEach(t => t.className = "icon-me-gusta activo");
            });
    });


    window.addEventListener("scroll", () => {
        const Comentarios = document.getElementById("tokenLF");
        if (CommentsLoad === false && Comentarios != null) {
            if (window.scrollY > Comentarios.offsetTop - 1000) {
                CommentsLoad = true;
                LiveFyre.loadLivefyre(Cookie.LeerCookie('cookieLogin'), Cookie.LeerCookie('usuario%5Flogtkn'), Login.Login);
            }
        }
        if (FirstQuarter === true &&
            SecondQuarter === true &&
            ThirdQuarter === true &&
            FourthQuarter === true &&
            EventFinContenido === true &&
            EventFinSugerencias === true) {
            return true;
        }
        const scrollTop = $(window).scrollTop();
        const docHeight = $(document).height();
        const winHeight = $(window).height();
        const scrollPercent = (scrollTop) / (docHeight - winHeight);
        const scrollPercentRounded = Math.round(scrollPercent * 100);
        if (scrollPercentRounded > 25 && FirstQuarter === false) {
            FirstQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '25' });
            }
        }
        if (scrollPercentRounded > 50 && SecondQuarter === false) {
            SecondQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '50' });
            }
        }
        if (scrollPercentRounded > 75 && ThirdQuarter === false) {
            ThirdQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '75' });
            }
        }
        if (scrollPercentRounded === 100 && FourthQuarter === false) {
            FourthQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '100' });
            }
        }

        if (Utilities.scrolledIntoView(".fin-cuerpo") && EventFinContenido === false && window.dataLayer !== undefined) {
            EventFinContenido = true;
            dataLayer.push({ 'event': 'trackScroll', 'quartile': 'fin del contenido ' });

        }
        if (Utilities.scrolledIntoView("#comentarios") && EventFinSugerencias === false && window.dataLayer !== undefined) {
            EventFinSugerencias = true;
            dataLayer.push({ 'event': 'trackScroll', 'quartile': 'fin caja sugerencias' });
        }

    });

    //window.onscroll = () => {


    //}
}


const obtenerComentarios = () => {
    const Comentarios = document.getElementById("tokenLF");
    if (Comentarios !== null) {
        let comentarioSpan = document.querySelectorAll('span[data-id="contadorComentarios"]'); //data-lf-site-id="@Model.SiteIdLF" data-lf-article-id="@Model.EntradaId"
        for (let span of comentarioSpan) {
            span.setAttribute("data-lf-site-id", Comentarios.getAttribute("data-lf-siteId"));
            span.setAttribute("data-lf-article-id", Comentarios.getAttribute("data-entrada"));
        }


        let script = document.createElement("script");
        script.type = "text/javascript";
        script.setAttribute("data-lf-domain", "la-nacion.fyre.co");
        script.src = "https://cdn.livefyre.com/libs/commentcount/v1.0/commentcount.js";
        document.body.appendChild(script);
        let verLegales = document.getElementsByClassName("ver-legales")[0];
        let legales = document.getElementsByClassName("legales")[0];

        verLegales.addEventListener("click", () => {
            verLegales.classList.toggle("flecha-arriba");
            legales.classList.toggle("desplegado");
        });
    }
}

const getTableros = () => {
    const tablero = document.querySelector("section.tablero");
    if (tablero != null) {
        var tableros = []; /*array de objetos de tipo tablero*/
        if (hasClass(tablero, "tenis")) {
            tableros.push(TableroTenis.agregarTableroTenis(document.querySelector(".tenis").getAttribute("data-id"), '1000'));
        } else if (hasClass(tablero, "futbol")) {
            tableros.push(TableroFutbol.agregarTableroFutbol(document.querySelector(".futbol").getAttribute("data-id"), '1101'));
        } else if (hasClass(tablero, "rugby")) {
            tableros.push(TableroRugby.agregarTableroRugby(document.querySelector(".rugby").getAttribute("data-id"), '1101'));
        } else if (hasClass(tablero, "basquet")) {
            tableros.push(TableroBasquet.agregarTableroBasket(document.querySelector(".basquet").getAttribute("data-id"), '1101'));
        }

        Tablero.iniciarTableros(tableros);
        Tablero.verificarCambiosCodigoControl();
        setInterval(Tablero.verificarCambiosCodigoControl, 15000);
    }
}

function hasClass(element, classNode) {
    return (' ' + element.className + ' ').indexOf(' ' + classNode + ' ') > -1;
}

const techos = () => {
    const classMain = document.querySelector('div[data-classMain]').getAttribute('data-classMain').trim();
    const nodoMain = document.querySelector('main');
    for (let className of classMain.split(" ")) {
        if (classMain.indexOf(" ") == -1)
            nodoMain.classList.add(className.trim());
    }
}

const bannersRepetidos = () => {
    let node = Array.from(document.querySelectorAll('#caja_1[data-dispositivo="tablet"]'));
    (node.length > 1) ? node[1].classList.remove("ad-slot"): "";
    node = Array.from(document.querySelectorAll('#caja_2[data-dispositivo="tablet"]'));
    (node.length > 1) ? node[1].classList.remove("ad-slot"): "";
}

const loadLiveBlog = (templateId) => {
    if (templateId == 6) {
        LiveBlog.loadEventoLiveBlog();
    }

}

const initialize = () => {
    let templateId = document.querySelector('div[data-templateId]').getAttribute("data-templateId");
    loadLiveBlog(templateId);
    if (templateId != 5) {
        bannersRepetidos();
        Personalizacion.initPreferencias("nota");
        //Sugerencias.sugerencias();
        Banners.loadBanners(window.LN.tipoPaginaBanner);
        Session.init();
        techos();
    }
    const divElement = document.querySelectorAll("#slider");
    Galeria.getAllGalerias(divElement);
    Tercera.getRanking();
    getTableros();
    Login.Initialize();
    Logout.Initialize();
    obtenerComentarios();
    NotasAdicionales.notasAdemas();
    Tercera.getPromoContentLab();
    Tercera.getPromoClubLn();
    Functions.functions();
    Functions.buscador();
    Functions.share();
    Functions.bannerHeaderLogo();
    bomba.checkBomba();
    CustomDimension.MakeCustomDimension();
    NotaCustomDimension.MakeCustomDimension();
    Sugerencias.getSugerenciasPie();
    Sugerencias.getNewsletter();
    NotasAdicionales.notasMasComentadas();
    eventsMetrics();
    Footer.linksFooter();
    Video.initialize();
    Pym.initIframePym();
    Utilities.metaRefresh(600000, "nota");
    shareClickEvents();
}

app.start().then(initialize);


// WEBPACK FOOTER //
// ./Statics/nota.js